import { defaultVariables, urls } from '../../referenceData';
import { fetchWithRetry } from '../index';

let loadingPromise;
let output;

export default async () => {
  if (loadingPromise) {
    await loadingPromise;
  }

  if (output) {
    return output;
  } else {
    let resolveLoadingPromise;
    loadingPromise = new Promise(function (resolve, reject) {
      resolveLoadingPromise = resolve;
    });
    try {
      const yearRequests = defaultVariables.default_year_array.map((yr) =>
        fetchWithRetry(
          `${urls.apiUrl()}data/?format=json&year1=${yr}&year2=${yr}&to_level=5&_v=${process.env.VERSION}`, // eslint-disable-line i18next/no-literal-string
        ),
      );

      const allData = await Promise.all(yearRequests);
      const flattened = (
        await Promise.all(
          allData.map(async (data) => {
            return (await data.json()).data;
          }),
        )
      ).flat();

      output = flattened;

      return flattened;
    } catch (err) {
      console.error(err);
    }
  }
};
